// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 *
 * @export
 * @interface Agent
 */
export interface Agent {
  /**
   *
   * @type {number}
   * @memberof Agent
   */
  id: number;
  /**
   * Unique per project
   * @type {string}
   * @memberof Agent
   */
  name: string;
  /**
   * Slug of the agent type definition this agent was created from
   * @type {string}
   * @memberof Agent
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof Agent
   */
  description?: string;
  /**
   * Disabled agents keep their config but cannot be run or assigned
   * @type {boolean}
   * @memberof Agent
   */
  enabled?: boolean;
  /**
   * Appended after the system and agent level prompts
   * @type {string}
   * @memberof Agent
   */
  customPrompt?: string;
  /**
   * Values for the config inputs declared by the agent type definition. Keys are the input names from that definition, so they vary by type. A secret input holds the project secret's ID, never the secret value.
   * @type {{ [key: string]: string; }}
   * @memberof Agent
   */
  config?: { [key: string]: string };
  /**
   * Project ID
   * @type {number}
   * @memberof Agent
   */
  project: number;
  /**
   * User ID of the backing agent identity, used when assigning test cases to this agent
   * @type {number}
   * @memberof Agent
   */
  user?: number;
  /**
   *
   * @type {number}
   * @memberof Agent
   */
  createdBy?: number;
  /**
   *
   * @type {number}
   * @memberof Agent
   */
  updatedBy?: number;
  /**
   *
   * @type {string}
   * @memberof Agent
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof Agent
   */
  updatedAt?: string;
}

export function AgentFromJSON(json: any): Agent {
  return {
    id: json["id"],
    name: json["name"],
    type: json["type"],
    description: !exists(json, "description") ? undefined : json["description"],
    enabled: !exists(json, "enabled") ? undefined : json["enabled"],
    customPrompt: !exists(json, "custom_prompt")
      ? undefined
      : json["custom_prompt"],
    config: !exists(json, "config") ? undefined : json["config"],
    project: json["project"],
    user: !exists(json, "user") ? undefined : json["user"],
    createdBy: !exists(json, "created_by") ? undefined : json["created_by"],
    updatedBy: !exists(json, "updated_by") ? undefined : json["updated_by"],
    createdAt: !exists(json, "created_at") ? undefined : json["created_at"],
    updatedAt: !exists(json, "updated_at") ? undefined : json["updated_at"],
  };
}

export function AgentToJSON(value?: Agent): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    name: value.name,
    type: value.type,
    description: value.description,
    enabled: value.enabled,
    custom_prompt: value.customPrompt,
    config: value.config,
    project: value.project,
    user: value.user,
    created_by: value.createdBy,
    updated_by: value.updatedBy,
    created_at: value.createdAt,
    updated_at: value.updatedAt,
  };
}
